import {SHA512, AES} from 'crypto-js';
export class Session {
    id: string;
    expire: number;
    started: number;
    name: string;
    // members: Device[];

    static getSessionFromJson(object: any): Session {
        const s = new Session();
        s.id = object.id;
        s.expire = object.expire;
        s.started = object.started;
        s.name = object.name;
        return s;
    }

    public getEncryptedSessionID(key: string) {
        const sha512 = SHA512(this.id, key).toString();
        const aes = AES.encrypt(this.id, key).toString();
        return aes;
    }
}

export class Device {
    user_id: string;
    device_name: string;
    device_os: string;
    device_id: string;
    device_marketname: string;

    static getDeviceFromJson(object: any): Device {
        const D = new Device();
        D.user_id = object.user_id;
        D.device_name = object.device_name;
        D.device_os = object.device_os;
        D.device_id = object.device_id;
        D.device_marketname = object.device_marketname;
        return D;
    }
}



// WEBPACK FOOTER //
// ./src/app/session.ts